// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"7d22173d","312":"3e84d03e","551":"b77da46a","950":"d26e2b10"}[chunkId] + ".chunk.js";
};